export const OFFER_ANCHOR = '#offer'
export const CHECKOUT_URL = 'https://metal-fabrication-ready.impultienda.ar/'
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/3LiEmBhx2FPddPAP29uKik/ChatGPT_Image_1_sept_2026,_10_30_05_p.m..png'
export const PIXEL_ID = '1086781087036952'
